import { Component } from 'react'

import { withRouter } from 'react-router-dom'

const createCookie = (name, value, days) => {
  let expires = ""
  if (days) {
    let date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  }
  else expires = "";

  document.cookie = name+"="+value+expires+"; path=/";
}

const queries = ['source', 'medium', 'campaign', 'content', 'term', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

class SetCookie extends Component {
  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search)
    for(var pair of query.entries()) {
      if(queries.indexOf(pair[0]) >= 0)
        createCookie(pair[0].replace('utm_', ''), pair[1], 30);
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(SetCookie)



// WEBPACK FOOTER //
// ./src/components/SetCookie.js